import { useEffect, useRef, useState } from 'react'
import { Page } from 'react-pdf'

const ESTIMATED_PAGE_HEIGHT = 850

const ROOT_MARGIN = '800px 0px'

type Props = {
  pageNumber: number
  className?: string
}

export const LazyPage = ({ pageNumber, className }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [renderedHeight, setRenderedHeight] = useState<number | null>(null)

  useEffect(() => {
    const el = containerRef.current
    if (!el) {
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting)
      },
      { rootMargin: ROOT_MARGIN, threshold: 0 },
    )

    observer.observe(el)
    return () => {
      observer.disconnect()
    }
  }, [])

  const handleRenderSuccess = () => {
    const pageEl = containerRef.current?.querySelector('.react-pdf__Page') as HTMLElement | null
    if (pageEl) {
      const height = pageEl.getBoundingClientRect().height
      if (height > 0) {
        setRenderedHeight(height)
      }
    }
  }

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ minHeight: renderedHeight ?? ESTIMATED_PAGE_HEIGHT }}>
      {isVisible ? (
        <Page
          pageNumber={pageNumber}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          onRenderSuccess={handleRenderSuccess}
        />
      ) : null}
    </div>
  )
}
